/* Newsletter-Slide-in "Post aus dem Forsthaus" (snippets/newsletter-popup.liquid, Regeln dort).
   Merkt sich nur Zeitstempel im localStorage (fh_nl_closed, fh_nl_done) und die Seitenaufrufe der Sitzung im sessionStorage (fh_pv).
   Fällt der Speicher aus, zeigt das Skript nichts. Es lädt nichts nach und setzt keine Cookies. */
(() => {
  const d = document;
  const el = d.querySelector('[data-newsletter-popup]');
  if (!el) return;

  const DELAY = Math.max(5, parseInt(el.dataset.delay, 10) || 20) * 1000;
  const PAGES = Math.max(1, parseInt(el.dataset.pages, 10) || 2);
  const QUIET = (parseInt(el.dataset.quietDays, 10) || 30) * 86400000;
  const K_CLOSED = 'fh_nl_closed';
  const K_DONE = 'fh_nl_done';
  const K_PV = 'fh_pv';
  const FORM_HASH = '#NewsletterPopup';
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  const read = (store, key) => {
    try { return store.getItem(key); } catch (_) { return null; }
  };
  const write = (store, key, value) => {
    try { store.setItem(key, value); return true; } catch (_) { return false; }
  };

  let shown = false;
  let timerDone = false;
  let consentOk = false;

  const hide = () => {
    el.classList.remove('is-open');
    if (reduce()) el.hidden = true;
    else setTimeout(() => { el.hidden = true; }, 260);
  };
  const show = () => {
    shown = true;
    el.hidden = false;
    /* zwei Frames Pause, damit die Einblendung läuft */
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
  };
  const close = () => {
    write(localStorage, K_CLOSED, String(Date.now()));
    shown = true;
    hide();
  };

  el.addEventListener('click', (e) => {
    if (e.target.closest('[data-newsletter-popup-close]')) close();
  });
  el.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  /* Rückkehr vom Absenden: Meldung zeigen (nur wenn das Formular des Slide-ins abgeschickt wurde), danach nie wieder fragen */
  const ok = el.querySelector('.form-message--success');
  const err = el.querySelector('.form-message--error');
  const mine = location.hash === FORM_HASH;
  if (ok) {
    write(localStorage, K_DONE, String(Date.now()));
    if (mine) {
      show();
      ok.focus({ preventScroll: true });
      setTimeout(hide, 8000);
    }
    return;
  }
  if (err && mine) {
    show();
    return;
  }

  if (read(localStorage, K_DONE)) return;
  const closedAt = parseInt(read(localStorage, K_CLOSED), 10);
  if (closedAt && Date.now() - closedAt < QUIET) return;

  /* Seitenaufrufe in dieser Sitzung zählen (ohne Speicher: kein Slide-in) */
  const pv = (parseInt(read(sessionStorage, K_PV), 10) || 0) + 1;
  if (!write(sessionStorage, K_PV, String(pv))) return;
  if (pv < PAGES) return;

  const blocked = () => {
    if (d.querySelector('dialog[open]')) return true;
    const a = d.activeElement;
    if (a && a !== d.body && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    /* Am Handy liegt auf Produktseiten die Kaufleiste unten */
    if (matchMedia('(max-width: 899px)').matches && d.querySelector('.sticky-atc')) return true;
    return false;
  };
  const scrolledEnough = () => {
    const h = d.documentElement.scrollHeight - innerHeight;
    return h <= 0 || scrollY / h >= 0.3;
  };

  const tryOpen = () => {
    if (shown || !timerDone || !consentOk || !scrolledEnough()) return;
    if (blocked()) return;
    removeEventListener('scroll', tryOpen);
    clearInterval(poll);
    show();
  };

  /* Cookie-Entscheidung abwarten: Banner aktiv und noch offen, dann erst nach visitorConsentCollected */
  const checkConsent = () => {
    const c = window.Shopify && window.Shopify.customerPrivacy;
    if (c && typeof c.shouldShowBanner === 'function') {
      try { return !c.shouldShowBanner(); } catch (_) { return true; }
    }
    return true;
  };
  consentOk = checkConsent();
  d.addEventListener('visitorConsentCollected', () => {
    consentOk = true;
    setTimeout(tryOpen, 1500);
  });
  /* Die API lädt manchmal erst nach dem Skript, und ein blockierender Zustand (Tippen, Dialog) kann enden: regelmäßig neu prüfen */
  const poll = setInterval(() => {
    if (!consentOk) consentOk = checkConsent();
    tryOpen();
  }, 1500);

  setTimeout(() => {
    timerDone = true;
    if (!consentOk) consentOk = checkConsent();
    addEventListener('scroll', tryOpen, { passive: true });
    tryOpen();
  }, DELAY);
})();
